import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { useSendNotificationForShipment } from './hooks';
import messages from './messages';

const SendNotificationsButton = ({ isEnabled, fulfillmentPlanId }) => {
  const sendNotifications = useSendNotificationForShipment([fulfillmentPlanId]);

  return (
    <DropdownMenuItem disabled={!isEnabled} onClick={sendNotifications}>
      <FormattedMessage {...messages.sendNotifications} />
    </DropdownMenuItem>
  );
};

SendNotificationsButton.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default SendNotificationsButton;
